var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-0{fill:none;}\n            .cls-1{fill:#fff;}\n            .cls-2{fill:#efeff0;}\n            .cls-3{fill:#d2ddfa;}\n            .cls-4{fill:#b4c6fa;}\n            .cls-5{fill:#4a77f6;}\n            .cls-6{fill:#668fff;}\n            .cls-7{fill-rule:evenodd;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,8a1,1,0,0,0-1,1v1.09l1.81-1.64A1,1,0,0,0,14,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,14.6V12.37a1,1,0,1,0-2,0V14a1,1,0,0,1-2,0V12.37a3,3,0,1,1,6,0v1.36l2-1.82V9a3,3,0,0,1,5.3-1.91l6.08-5.53A2,2,0,0,0,21,1H3A2,2,0,0,0,1,3V19a2,2,0,0,0,.62,1.44l5.51-5A2.88,2.88,0,0,1,7,14.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.38,1.56,16.3,7.09A3,3,0,0,1,17,9v1.47a1,1,0,0,0,2,0v-.1a1,1,0,1,1,2,0v.1a3,3,0,0,1-6,0V9a1,1,0,0,0-.19-.55L13,10.09V14.6a3,3,0,0,1-5.87.83l-5.51,5A2,2,0,0,0,3,21H21a2,2,0,0,0,2-2V3A2,2,0,0,0,22.38,1.56Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,15.6a1,1,0,0,0,1-1V11.91L9,13.73v.87A1,1,0,0,0,10,15.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2 cls-7",
    d: "M7,22H17a1,1,0,0,1,0,2H7a1,1,0,0,1,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.645424f57e5a43680af091c62cc0c1f6.svg";
export { ForwardRef as ReactComponent };